export default __webpack_public_path__ + "static/media/casinoh24_receipt.57deee12.jpg";